// extracted by mini-css-extract-plugin
module.exports = {"customSearch":"MegaMenu_customSearch__tlxmk","faCustom":"MegaMenu_faCustom__29Ytg","itemList":"MegaMenu_itemList__dKMi7"};